import { ReactNode } from 'react';
import { TableCellTextMR } from '../TableCellTextMR';

export const makeCellTextRenderers = () => {
  const text = (value: ReactNode) => <TableCellTextMR>{value}</TableCellTextMR>;
  const textU = (value: ReactNode) => <TableCellTextMR uppercase>{value}</TableCellTextMR>;
  return { text, textU };
};
